import { TableCell, TableRow } from '@mui/material'
import cn from 'classnames'
import React from 'react'
import { formatPercentage, formatUSD, formatWAX } from '../helpers/FormatLinks'

const MarketRankingElement = (props) => {
    const index = props['index']

    const { market, stats } = props['volume']

    const { waxVolume, usdVolume, change, sales, sellers, buyers } = stats

    const color =
        parseFloat(change) > 0
            ? 'text-green-600'
            : parseFloat(change * 100) < 0
            ? 'text-red-600'
            : 'text-white'

    const link = (children) => {
        return <div>{children}</div>
    }

    const textClass = cn('px-2 py-4')

    return (
        <TableRow
            key={'ranking-detail-row' + index}
            className={cn(
                'text-white hover:text-primary hover:font-bold hover:bg-zinc-300 dark:hover:!bg-paperl transition-colors duration-300',
            )}
        >
            <TableCell className={cn(textClass, 'text-left')}>
                <div
                    className={'text-black dark:!text-white hover:text-primary'}
                >
                    {link(index + 1)}
                </div>
            </TableCell>
            <TableCell className={cn(textClass, 'text-left')}>
                <div
                    className={'text-black dark:!text-white hover:text-primary'}
                >
                    {link(market)}
                </div>
            </TableCell>
            <TableCell className={cn(textClass, 'text-middle')}>
                <div
                    className={'text-black dark:!text-white hover:text-primary'}
                >
                    {link(formatWAX(waxVolume))}
                </div>
            </TableCell>
            <TableCell className={cn(textClass, 'text-middle')}>
                <div
                    className={'text-black dark:!text-white hover:text-primary'}
                >
                    {link(formatUSD(usdVolume))}
                </div>
            </TableCell>
            <TableCell className={cn(textClass, 'text-right', color)}>
                <div
                    className={'text-black dark:!text-white hover:text-primary'}
                >
                    {link(formatPercentage(change))}
                </div>
            </TableCell>
            <TableCell className={cn(textClass, 'text-right')}>
                <div
                    className={'text-black dark:!text-white hover:text-primary'}
                >
                    {link(buyers.toLocaleString(undefined))}
                </div>
            </TableCell>
            <TableCell className={cn(textClass, 'text-right')}>
                <div
                    className={'text-black dark:!text-white hover:text-primary'}
                >
                    {link(sellers.toLocaleString(undefined))}
                </div>
            </TableCell>
            <TableCell className={cn(textClass, 'text-right')}>
                <div
                    className={'text-black dark:!text-white hover:text-primary'}
                >
                    {link(sales.toLocaleString(undefined))}
                </div>
            </TableCell>
        </TableRow>
    )
}

export default MarketRankingElement
